import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const filesStatusesSlice = createSlice({
  name: "filesStatuses",
  initialState: {},
  reducers: {
    setFilesStatusesData: (_state: any, action: PayloadAction<any>) =>
      action.payload.reduce((prev: Record<string, any>, curr: any) => {
        if (curr.name.toLowerCase() == "deleted") {
          return prev;
        }
        return { ...prev, [curr.id]: curr };
      }, {}),
  },
});

const currentPathSlice = createSlice({
  name: "currentPath",
  initialState: null,
  reducers: {
    setCurrentPath: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setFilesStatusesData } = filesStatusesSlice.actions;
export const { setCurrentPath } = currentPathSlice.actions;

export const filesStatuses = filesStatusesSlice.reducer;
export const currentPath = currentPathSlice.reducer;

export default filesStatusesSlice.reducer;
